import { Injectable } from '@angular/core';
import { FiUserDataService } from './fi-user-data.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { FiItemsListType } from '@fi-shared/fi-items-list/fi-items-list-type';

@Injectable()
export class UserPreferencesService {
    private helper: {
        getProperty: (objectType, propertyName) => any;
        saveProperty: (objectType, propertyName, value) => any;
        clearProperty: (propertyName) => any;
    };
    constructor(private userDataService: FiUserDataService) {
        this.helper = (function () {
            var data = localStorage.getItem('CCMUserPreferences');
            var userPreferences = data ? JSON.parse(data) : {};

            function getUserPreferences() {
                const userId = userDataService.getUserId();
                return userPreferences[userId] || {};
            }
            function saveUserPreferences(item) {
                const userId = userDataService.getUserId();
                userPreferences[userId] = item;
                localStorage.setItem('CCMUserPreferences', JSON.stringify(userPreferences));
            }

            return {
                getProperty: function (objectType, propertyName) {
                    var preferences = getUserPreferences();
                    return preferences[propertyName] ? preferences[propertyName][objectType] : null;
                },
                saveProperty: function (objectType, propertyName, value) {
                    var preferences = getUserPreferences();
                    if (!preferences[propertyName]) preferences[propertyName] = {};
                    preferences[propertyName][objectType] = value;
                    saveUserPreferences(preferences);
                },
                clearProperty: (propertyName) => {
                    const preferences = getUserPreferences();
                    preferences[propertyName] = {};
                    saveUserPreferences(preferences);
                },
            };
        })();
    }

    getListSort(itemsListType: FiItemsListType) {
        const key = this.getListSortKey(itemsListType);
        return this.helper.getProperty(key, 'ListSortData');
    }
    saveListSort(itemsListType: FiItemsListType, value: any) {
        const key = this.getListSortKey(itemsListType);
        this.helper.saveProperty(key, 'ListSortData', value);
    }
    private getListSortKey(itemsListType: FiItemsListType) {
        return FiItemsListType[itemsListType];
    }

    getListDisplayType(itemsListType: FiItemsListType) {
        const key = FiItemsListType[itemsListType];
        return this.helper.getProperty(key, 'ListDisplayType');
    }
    saveListDisplayType(itemsListType: FiItemsListType, value: any) {
        const key = FiItemsListType[itemsListType];
        this.helper.saveProperty(key, 'ListDisplayType', value);
        this._onListDisplayTypeUpdate$.next(itemsListType);
    }

    getIsCompactMode() {
        return this.helper.getProperty(null, 'IsCompactMode') || false;
    }
    saveIsCompactMode(value) {
        this.helper.saveProperty(null, 'IsCompactMode', value);
    }

    clearListSort() {
        this.helper.clearProperty('ListSortData');
    }

    private _onListDisplayTypeUpdate$ = new BehaviorSubject<FiItemsListType>(undefined);
    onListDisplayTypeUpdate$(): Observable<FiItemsListType> {
        return this._onListDisplayTypeUpdate$.asObservable();
    }
}
